import React from 'react'

export default function WebhooksNav(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#747894" {...props}>
    <circle cx="18" cy="5" r="3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="6" cy="12" r="3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="18" cy="19" r="3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.59 13.51l6.83 3.98" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.41 6.51l-6.82 3.98" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
